import { createFileRoute } from '@tanstack/react-router'

import { useAcceptChangeIdentityEmail } from '@/gen/publicApi'

import { Button } from '@/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/card'
import Spinner from '@/components/spinner'

export const Route = createFileRoute('/change-email/$change_email_token/')({
    component: ChangeEmail,
})

function ChangeEmail() {
    const { change_email_token } = Route.useParams()
    const acceptChange = useAcceptChangeIdentityEmail(change_email_token, {
        query: {
            retry: false,
        },
    })
    const returnHome = () => {
        // Hard refresh so that the identity is totally reloaded
        window.location.href = '/'
    }

    if (acceptChange.isLoading) {
        return <Spinner size="md" absolute />
    }

    if (acceptChange.error) {
        return (
            <Card className="absolute-center w-96">
                <CardHeader>
                    <CardTitle>Error</CardTitle>
                </CardHeader>
                <CardContent>
                    <CardDescription className="mb-4">
                        Something went wrong and we could not update your email address
                    </CardDescription>
                    <Button className="mt-4" onClick={returnHome}>
                        Return home
                    </Button>
                </CardContent>
            </Card>
        )
    }

    return (
        <Card className="absolute-center w-96">
            <CardHeader>
                <CardTitle>Email changed</CardTitle>
            </CardHeader>
            <CardContent>
                <CardDescription className="mb-4">Your email has been updated!</CardDescription>
                <Button className="mt-4" onClick={returnHome}>
                    Return home
                </Button>
            </CardContent>
        </Card>
    )
}
